import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from "axios";
import { setUserInput } from '../ec-chat-page/ecChatSlice'

import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';
import { Feedback } from '../feedback';

const AsrChat = () => {
    const dispatch = useDispatch();
    const userInputText = useSelector((state) => state.ecChat.userInput);
    // const enUserInputText = useSelector((state) => state.asr.enText);
    // const userInputText = bnUserInputText === "" ? "" : "বাংলা: " + bnUserInputText + "\n\nEnglish: " + enUserInputText;

    const appToken = useSelector((state) => state.auth.appToken);

    const updateBnText = (input) => {
        dispatch(setUserInput(input))
    }

    
    return (
        <div className='asr mini-card'>
            <h4>User Input</h4>
            <div>
                <textarea
                    value={userInputText}
                    rows="5" style={{"width": "100%"}}
                    readOnly />
            </div>           
            <div>                
                <Feedback 
                    type = {"asr"} />                
            </div>
        </div>
    );
};


export default AsrChat;